import { useContext, useEffect } from "react";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/global-context-provider";
import { gql, useMutation } from "@apollo/client";

const SyncCart = () => {
  const { cart, cartRevision, cartExternalRevision, cartSyncInProgress } =
    useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const [emptyCart] = useMutation(EMPTY_CART);
  const [addCartItems] = useMutation(ADD_CART_ITEMS);

  const mapAttributes = (attributes) => {
    return Object.entries(attributes).map(
      ([attributeName, attributeValue]) => ({
        attributeName,
        attributeValue,
      })
    );
  };

  const syncCart = async () => {
    if (
      cartRevision > 0 &&
      cartRevision !== cartExternalRevision &&
      !cartSyncInProgress
    ) {
      dispatch({
        type: "SYNC_CART",
        cartExternalRevision: cartExternalRevision,
        cartSyncInProgress: true,
      });
      emptyCart()
        .catch(() => true)
        .then(() => {
          if (cart.length > 0) {
            return addCartItems({
              variables: {
                cartItems: cart.map(({ id, quantity, attributes }) => ({
                  productId: id,
                  quantity,
                  variation: attributes ? mapAttributes(attributes) : null,
                })),
              },
            });
          } else {
            return false;
          }
        })
        .then(() => {
          dispatch({
            type: "SYNC_CART",
            cartExternalRevision: cartRevision,
            cartSyncInProgress: false,
          });
        })
        .catch(() => {
          window.localStorage.removeItem("local_cart");
          location.reload();
        });
    }
  };

  useEffect(() => {
    syncCart();
  }, [cartSyncInProgress, cartRevision, cartExternalRevision]);

  return null;
};

export default SyncCart;

const EMPTY_CART = gql`
  mutation EmptyCart {
    emptyCart(input: { clearPersistentCart: true }) {
      deletedCart {
        contents {
          nodes {
            quantity
            product {
              node {
                databaseId
              }
            }
            variation {
              attributes {
                name
                value
              }
            }
            extraData {
              key
              value
            }
          }
        }
      }
    }
  }
`;

const ADD_CART_ITEMS = gql`
  mutation AddCartItems($cartItems: [CartItemInput]) {
    addCartItems(input: { items: $cartItems }) {
      clientMutationId
    }
  }
`;
